import React from 'react';

const Spinner = ({ size = '20px', color = '#fff' }) => {
  return (
    <div style={{
      width: size,
      height: size,
      border: `3px solid rgba(255,255,255,0.3)`,
      borderTop: `3px solid ${color}`,
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
      display: 'inline-block'
    }} />
  );
};

export default Spinner;
